import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import {
  Gallery,
  GalleryItem,
  ThumbnailsPosition,
  ImageSize,
  ImageItem,
} from 'ng-gallery';
import { Lightbox } from 'ng-gallery/lightbox';
import { UserManagementService } from 'src/app/Service/user-management.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { MatSort, Sort } from '@angular/material/sort';
import { DomSanitizer } from '@angular/platform-browser';
import { ChangeDetectorRef } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { UserProfileComponent } from 'src/app/modals/user-profile/user-profile.component';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss'],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentComponent implements OnInit {
  displayedColumns: string[] = [
    'personName',
    'phoneNo',
    'documentStatus',
    'Address',
    'verificationHistory',
  ];
  dataSource;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  selection = new SelectionModel<PeriodicElement>(true, []);

  src = 'https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf';
  pdfSrc = 'http://www.pdf995.com/samples/pdf.pdf';

  //Image Viewer
  //items: GalleryItem[];
  @ViewChild('itemTemplate', { static: true }) itemTemplate: TemplateRef<any>;
  //imageData = data;
  selectedIndex = -1;
  userlist = [];
  userdata;
  restrictbutton = false;
  ReasonForReject;
  filtershow = true;
  filter: string;
  mainata = true;
  view_profile = false;
  avtar = false;
  imageShow1;
  documentshow = false;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  fruits: any = [];
  public matChipArray = [];
  exportcsvdata = false;
  documentbutton = true;
  totalcount;
  totalTrader;
  totalTraderStaticData = [];

  resonForReject = [
    { value: 0, viewValue: 'Incorrect documents' },
    { value: 1, viewValue: 'Document not readable' },
    { value: 2, viewValue: 'Details mismatch post verification' },
    { value: 3, viewValue: 'Others' },
  ];

  statusList = [
    { value: 0, viewValue: 'All' },
    { value: 1, viewValue: 'Pending Submission' },
    { value: 2, viewValue: 'Pending Verification' },
    { value: 3, viewValue: 'Verified' },
    { value: 4, viewValue: 'Rejected' },
  ];

  otherReasonText = '';
  otherReason = false;

  docDetails = false;
  constructor(
    private router: Router,
    public toastr: ToastrService,
    public gallery: Gallery,
    private spinner: NgxSpinnerService,
    public lightbox: Lightbox,
    public _userService: UserManagementService,
    private sanitizer: DomSanitizer,
    private ref: ChangeDetectorRef,
    public dialog: MatDialog
  ) {}
  //    this.ref.detectChanges();
  ngOnInit(): void {
    // this.dataSource.paginator = this.paginator;
    this.selectedIndex = 1;
    this.spinner.show();

    //this.statusdata = this.statusList[0].viewValue;

    setTimeout(() => {
      this.spinner.hide();
    }, 4000);
    const lightboxRef = this.gallery.ref('lightbox');
    // Add custom gallery config to the lightbox (optional)
    lightboxRef.setConfig({
      imageSize: ImageSize.Cover,
      thumbPosition: ThumbnailsPosition.Top,
      itemTemplate: this.itemTemplate,
      gestures: false,
    });
    // Load items into the lightbox gallery ref
    // lightboxRef.load(this.items);
    // this.showimage();
    this.getAlluser();
    if (localStorage.getItem('UserRole') == 'ADMIN') {
      this.restrictbutton = false;
    } else {
      this.restrictbutton = true;
    }

    this.getStaticData();
  }

  getOthereason(data) {
    if (data.viewValue === 'Others') {
      this.otherReason = true;
    } else {
      this.otherReason = false;
    }
  }

  docdisable = false;
  doclength;
  getAlluser() {
    var postdata = {
      userId: '',
      userRole: 'Trader',
      name: '',
      state: '',
      documentStatus: '',
      district: '',
      marketPlace: '',
      search: '',
      mobileNo: '',
      pageNumber: 0,
      adminRole: localStorage.getItem('UserRole'),
    };
    this._userService.getAllUser(postdata).subscribe((data) => {
      this.userdata = data;
      this.userlist = this.userdata.result.data.list;
      this.paginationProperty = this.userdata.result.data;
      this.length = this.paginationProperty.totalItems;
      this.totalcount = this.paginationProperty.totalItems;
      this.previousPageIndex = this.paginationProperty.previousPageIndex;
      this.hasNextPage = this.paginationProperty.hasNextPage;
      this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
      this.pageIndex = this.paginationProperty.pageNumber;

      for (let i = 0; i < this.userlist.length; i++) {
        // debugger
        if (this.userlist[i].docuement != null) {
          this.doclength = this.userlist[i].docuements.length;
          if (this.doclength == 0) {
            this.docdisable = false;
          } else {
            this.docdisable = true;
          }
        }
      }
      this.dataSource = new MatTableDataSource(this.userlist);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  getStaticData() {
    this._userService.getTraderStaticData().subscribe((data) => {
      this.totalTrader = data;
      this.totalTraderStaticData = this.totalTrader.result.data;
    });
  }

  showpdf() {
    this.selectedIndex = 2;
    this.pdfSrc = 'http://www.pdf995.com/samples/pdf.pdf';
    this.contentLoaded();
  }

  showImg() {
    this.selectedIndex = 3;
  }

  contentLoaded() {}

  filterDocuments;
  showurl;
  filterdocumentfrombase64;
  items: GalleryItem[];
  // imageData = data;

  documentlist = [];
  inprogress = false;
  rejected = false;
  listurl = [];
  base64;
  companyname;
  documentStatus;
  mandi;
  personName;
  phoneNo;
  role;
  states;
  imageSource;
  soure;
  items1;
  imgshow;
  TraderId;
  id_data;
  showurldata;
  showtext;
  items_url;
  items_find_url;
  iddocument;
  base123;
  test;
  pdfprint;
  pdfurl;
  pdfdata;
  filetype;
  filetypereal;
  address;
  emailId;
  rejectedReason;
  showDocument(data) {
    this.docDetails = true;
    this.showinput = false;
    this.documentbutton = false;
    this.spinner.show();
    setTimeout(() => {
      // this.selectedIndex = 3;
      this.spinner.hide();
    }, 6000);

    this.filterDocuments = data;
    this.id_data = data.personId;
    // this._userService.getdocumentlist(postdata).subscribe((dcumentdata)=>{
    //   this.iddocument = dcumentdata;
    // });
    // var postdata = {
    //   "userid":this.id_data,
    // }
    // this._userService.getdocumentlist(postdata).subscribe((dcumentdata)=>{
    //   this.base64 = dcumentdata;
    //   this.listurl =this.base64.result.data;
    //   this.items_url = this.listurl.map(item => new ImageItem(this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64,${item.documentUrl}`)));
    //   })
    if (this.filterDocuments.docuements != null) {
      if (this.filterDocuments.docuements.length == 0) {
        alert('There is no document uploaded under this trader');
        this.spinner.hide();
      } else {
        this.companyname = data.company;
        this.documentStatus = data.adminStatus;
        this.mandi = data.mandi;
        this.personName = data.personName;
        this.phoneNo = data.phoneNo;
        this.role = data.role;
        this.states = data.states;
        this.address = data.address;
        this.emailId = data.emailId;
        this.TraderId = data.personId;
        this.district = data.district;
        this.rejectedReason = data.rejectedReason;

        if (this.documentStatus == 'InProgress') {
          this.inprogress = true;
        } else if (this.documentStatus == 'InProgress') {
          this.rejected = true;
        }
        this.filterDocuments = data;
        this.documentlist = this.filterDocuments.docuements;
        // this.items = this.documentlist.map(item => new ImageItem({ src: item.documentUrl }));
        // this.filtershow =false;
        // this.selectedIndex = 3;
        // this.spinner.show();

        var postdata = {
          userid: this.id_data,
        };

        this._userService.getdocumentlist(postdata).subscribe((dcumentdata) => {
          // this.showDocument(data);
          setTimeout(() => {
            this.filtershow = false;
            this.selectedIndex = 3;
            this.base64 = dcumentdata;
            this.listurl = this.base64.result.data;
            this.filetype = this.listurl.map(
              (item) => new ImageItem({ src: item.documentType })
            );
            this.filetype.forEach((element) => {
              this.filetypereal = element.data.src;
            });
            // this.base123 = this.sanitizer.bypassSecurityTrustResourceUrl(`data:application/pdf;base64,${this.listurl[0].documentUrl}`);
            // this.test =this.base123.changingThisBreaksApplicationSecurity;
            this.pdfdata = this.listurl.map(
              (item) =>
                new ImageItem(
                  this.sanitizer.bypassSecurityTrustResourceUrl(
                    `data:application/pdf;base64,${item.documentUrl}`
                  )
                )
            );
            this.pdfprint = this.pdfdata.map(
              (item) =>
                new ImageItem({
                  src: item.data.changingThisBreaksApplicationSecurity,
                })
            );
            // this.pdfurl = this.pdfprint.map(item => new ImageItem({ src: item.data.src }));

            this.items_url = this.listurl.map(
              (item) =>
                new ImageItem(
                  this.sanitizer.bypassSecurityTrustResourceUrl(
                    `data:image/png;base64,${item.documentUrl}`
                  )
                )
            );
            this.items_find_url = this.items_url.map(
              (item) =>
                new ImageItem({
                  src: item.data.changingThisBreaksApplicationSecurity,
                })
            );

            // // this.spinner.hide()
            // this.filtershow =false;
            this.selectedIndex = 3;
            this.ref.detectChanges();

            // this.spinner.hide();
          });

          //  this.filtershow =false;
          //  this.selectedIndex = 3
        });

        // this.spinner.hide()
      }
    }

    // this.spinner.hide()
  }

  showinput = false;
  rejectionInput(val) {
    if (val == 'open') {
      this.showinput = true;
      this.otherReason = false;
      this.ReasonForReject = '';
    } else {
      this.showinput = false;
      this.otherReason = false;
      this.ReasonForReject = '';
    }
  }

  filterbyname = '';
  filterbyphone = '';
  filterbystate = '';
  filterbydocumentStatus = '';
  filterUserDetail(data: any, filtername) {
    if (filtername == 'name') {
      this.filterbyname = data;
    } else if (filtername == 'phone') {
      this.filterbyphone = data;
    }
    // else if (filtername == "documentStatus") {
    //   this.filterbydocumentStatus = data
    // }
    // else if(filtername == "state"){
    //     this.filterbystate = data
    // }
    else if (
      this.filterbyname == '' ||
      this.filterbyname == undefined ||
      this.filterbyphone == '' ||
      this.filterbyphone == undefined ||
      this.filterbydocumentStatus == '' ||
      this.filterbydocumentStatus == undefined
    ) {
      this.getAlluser();
    }
    // else(data == "" || data == undefined){
    //   this.getAlluser()
    // }

    var postdata = {
      userId: '',
      userRole: 'Trader',
      name: this.filterbyname,
      state: '',
      documentStatus:
        this.filterbydocumentStatus === 'All'
          ? ''
          : this.filterbydocumentStatus,
      district: '',
      marketPlace: '',
      search: '',
      mobileNo: this.filterbyphone,
      pageNumber: 0,
      adminRole: localStorage.getItem('UserRole'),
    };
    this._userService.getAllUser(postdata).subscribe((data) => {
      this.userdata = data;
      this.userlist = this.userdata.result.data.list;
      this.paginationProperty = this.userdata.result.data;
      this.length = this.paginationProperty.totalItems;
      this.previousPageIndex = this.paginationProperty.previousPageIndex;
      this.hasNextPage = this.paginationProperty.hasNextPage;
      this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
      this.pageIndex = this.paginationProperty.pageNumber;

      for (let i = 0; i < this.userlist.length; i++) {
        if (this.userlist[i].docuements != null) {
          this.doclength = this.userlist[i].docuements.length;
          if (this.doclength == 0) {
            this.docdisable = false;
          } else {
            this.docdisable = true;
          }
        }
      }
      this.dataSource = new MatTableDataSource(this.userlist);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  response;
  Updateverified(val) {
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 4000);

    if (val == 'reject') {
      var postdata = new FormData();
      postdata.append('userid', this.TraderId);
      postdata.append('IsVerified', 'false');
      postdata.append(
        'ReasonforRejection',
        this.ReasonForReject === 'Others'
          ? this.otherReasonText
          : this.ReasonForReject
      );
    } else {
      var postdata = new FormData();
      postdata.append('userid', this.TraderId);
      postdata.append('IsVerified', 'true');
      postdata.append('ReasonforRejection', '');
    }

    this._userService.postdocumentVerify(postdata).subscribe((data) => {
      this.response = data;
      this.spinner.hide();
      this.getAlluser();
      // var message:any = response.result.data
      // alert(message.message);
      this.toastr.success(this.response.result.message, '', {
        timeOut: 3000,
      });
    });
    this.getAlluser();
    this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
      this.spinner.show();
      setTimeout(() => {
        this.spinner.hide();
      }, 4000);
      this.getAlluser();
      this.router.navigate(['/document']);
    });
    this.spinner.hide();
  }

  showViews(index: number) {
    this.documentbutton = true;
    this.filtershow = true;

    this.selectedIndex = index;
  }
  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => this.selection.select(row));
  }

  /*.........................................PAGINATION CONFIG................................................. */
  paginationProperty;
  hasNextPage;
  hasPreviousPage;
  nextPageNumber;
  pageNumber;
  pageSize;
  previousPageNumber;
  totalItems;
  totalPages;
  pageEvent: PageEvent;
  datasource: null;
  pageIndex: number;
  length: number;
  previousPageIndex;
  pagechangeevent;
  public getServerData(event?: PageEvent) {
    this.pagechangeevent = event;
    this.pageIndex = this.pagechangeevent.pageIndex;
    this.length = this.pagechangeevent.length;
    this.pageSize = this.pagechangeevent.pageSize;
    if (this.exportcsvdata == true) {
      var postdata = {
        userId: '',
        userRole: 'Trader',
        name: '',
        state: '',
        documentStatus:
          this.filterbydocumentStatus === 'All'
            ? ''
            : this.filterbydocumentStatus,
        district: '',
        marketPlace: '',
        search: this.filterbytext,
        mobileNo: '',
        pageNumber: this.pageIndex,
        pageSize: this.pageSize,
        adminRole: localStorage.getItem('UserRole'),
      };
      this._userService.getAllUser(postdata).subscribe((data) => {
        this.userdata = data;
        this.userlist = this.userdata.result.data.list;

        this.paginationProperty = this.userdata.result.data;
        this.length = this.paginationProperty.totalItems;
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber;

        this.dataSource = new MatTableDataSource(this.userlist);
        this.dataSource.sort = this.sort;
        this.spinner.hide();
        this.ref.detectChanges();
      });
    } else {
      var postdata = {
        userId: '',
        userRole: 'Trader',
        name: '',
        state: '',
        documentStatus:
          this.filterbydocumentStatus === 'All'
            ? ''
            : this.filterbydocumentStatus,
        district: '',
        marketPlace: '',
        search: this.filterbytext,
        mobileNo: '',
        pageNumber: this.pageIndex,
        pageSize: this.pageSize,
        adminRole: localStorage.getItem('UserRole'),
      };
      this._userService.getAllUser(postdata).subscribe((data) => {
        this.userdata = data;
        this.userlist = this.userdata.result.data.list;

        this.paginationProperty = this.userdata.result.data;
        this.length = this.paginationProperty.totalItems;
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber;

        this.dataSource = new MatTableDataSource(this.userlist);
        this.dataSource.sort = this.sort;
        this.spinner.hide();
        this.ref.detectChanges();
      });
    }
  }
  // add by shivam modi for filter
  clearFilter() {
    this.spinner.show();
    window.location.reload();
  }
  // add by shivam modi

  district;
  taluk;
  numberOfTrees;
  treeType;
  commTradeInterest;
  reqFrequency;
  aboutUs;
  profile_Image;
  showDocument1(data) {
    this.selectedIndex = 4;
    this.view_profile = true;
    this.mainata = false;
    this.avtar = false;
    if (data.profile_Image == null) {
      this.avtar = true;
    }

    this.companyname = data.company;
    this.documentStatus = data.documentStatus;
    this.mandi = data.mandi;
    this.personName = data.personName;
    this.phoneNo = data.phoneNo;
    this.role = data.role;
    this.states = data.states;
    this.district = data.district;
    this.taluk = data.taluk;
    this.numberOfTrees = data.numberOfTrees;
    this.treeType = data.treeType;
    this.commTradeInterest = data.commTradeInterest;
    this.reqFrequency = data.reqFrequency;
    this.aboutUs = data.aboutUs;
    this.profile_Image = data.profile_Image;
  }
  showViews1() {
    this.mainata = true;
    this.selectedIndex = 1;
    this.view_profile = false;
    var postdata = {
      userId: '',
      userRole: 'Trader',
      name: '',
      state: '',
      documentStatus: '',
      search: '',
      district: '',
      marketPlace: '',
      mobileNo: '',
      pageNumber: 0,
      adminRole: localStorage.getItem('UserRole'),
    };

    this._userService.getAllUser(postdata).subscribe((data) => {
      this.userdata = data;
      this.userlist = this.userdata.result.data.list;
      this.paginationProperty = this.userdata.result.data;
      this.length = this.paginationProperty.totalItems;
      this.previousPageIndex = this.paginationProperty.previousPageIndex;
      this.hasNextPage = this.paginationProperty.hasNextPage;
      this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
      this.pageIndex = this.paginationProperty.pageNumber;

      for (let i = 0; i < this.userlist.length; i++) {
        if (this.userlist[i].docuements != null) {
          this.doclength = this.userlist[i].docuements.length;
          if (this.doclength == 0) {
            this.docdisable = false;
          } else {
            this.docdisable = true;
          }
        }
      }
      this.dataSource = new MatTableDataSource(this.userlist);
      // this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  newTab(url) {
    window.open(url, '_blank');
  }

  docList() {
    window.location.reload();
  }

  statusdata = '';
  filterbytext = '';
  searchdata = '';
  applyfilter(checkEmpty) {
    if (checkEmpty && !this.searchdata && !this.statusdata) {
      alert('Please provide input first');
    } else {
      this.exportcsvdata = true;
      this.filterbytext = this.searchdata;
      this.filterbydocumentStatus = this.statusdata;
      let indexstatus = this.matChipArray.findIndex((x) => x.tag === 'status');
      if (this.statusdata != '') {
        if (indexstatus > -1) {
          this.matChipArray[indexstatus].name =
            'Status' + ':' + this.statusdata;
        } else {
          if (this.statusdata != '' && this.statusdata != undefined) {
            this.matChipArray.push({
              name: 'Status' + ':' + this.statusdata,
              tag: 'status',
              flag: true,
            });
          }
        }
      }

      // if(this.filterbyrole !=  undefined || this.filterbyname !=  undefined ||this.filterbystate  !=  undefined )

      var postdata = {
        userId: '',
        userRole: 'Trader',
        name: '',
        state: '',
        documentStatus:
          this.filterbydocumentStatus === 'All'
            ? ''
            : this.filterbydocumentStatus,
        district: '',
        marketPlace: '',
        search: this.filterbytext,
        mobileNo: '',
        pageNumber: 0,
        adminRole: localStorage.getItem('UserRole'),
      };
      this._userService.getAllUser(postdata).subscribe((data) => {
        this.userdata = data;
        this.userlist = this.userdata.result.data.list;
        this.paginationProperty = this.userdata.result.data;
        this.length = this.paginationProperty.totalItems;
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber;
        this.dataSource = new MatTableDataSource(this.userlist);
        this.dataSource.sort = this.sort;
        this.spinner.hide();
        this.ref.detectChanges();
      });
    }
  }

  remove(index, tag): void {
    if (tag === 'status') {
      this.matChipArray.splice(index, 1);
      this.statusdata = '';
    }
    this.applyfilter(false);
    this.ref.detectChanges();
  }
  changeFn(event: any) {
    if (event.isTrusted == true) {
      this.applyfilter(false);
      this.ref.detectChanges();
    }
  }
  /*===================================================== Export File =========================================  */
  /*Export csv file */
  apidata;
  maindata;
  filename;

  exportcsv() {
    if (this.exportcsvdata == true) {
      this.applyfilter(true);
      var postdata = {
        userId: '',
        userRole: 'Trader',
        name: '',
        state: '',
        district: '',
        search: this.filterbytext,
        marketPlace: '',
        mobileNo: '',
        documentStatus: this.filterbydocumentStatus,
        // "adminRole": localStorage.getItem("UserRole")
      };
      this._userService.getAllUserdocumentpdf(postdata).subscribe((data) => {
        this.apidata = data;
        const blob = new Blob([this.apidata], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        var anchor = document.createElement('a');
        anchor.download = 'PKF_documentlist.xlsx';
        anchor.href = url;
        anchor.click();
        // window.open(url);
      });
    } else {
      var postdata = {
        userId: '',
        userRole: 'Trader',
        name: '',
        state: '',
        district: '',
        marketPlace: '',
        mobileNo: '',
        documentStatus: '',
        search: '',
        // "adminRole": localStorage.getItem("UserRole")
      };
      this._userService.getAllUserdocumentpdf(postdata).subscribe((data) => {
        this.apidata = data;
        const blob = new Blob([this.apidata], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        // window.open(url);
        var anchor = document.createElement('a');
        anchor.download = 'PKF_documentlist.xlsx';
        anchor.href = url;
        anchor.click();
      });
    }
  }

  versionHistory(x: any) {
    let url = window
      .open('./#/document-verification-history/' + x.personId, '_blank')
      .focus();

    // this.router.navigate(['/document-verification-history',x.personId]);
  }

  /*===================================================== Column Based Export File =========================================  */

  dialogresult;
  mainresult;
  openDialogexport(): void {
    const dialogRef = this.dialog.open(DocumentExport, {
      width: '61%',
      height: '67%',
      //  data: {id: data}
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogresult = result;
      //================================REPORT GENERATE==========================================//
      if (this.dialogresult != undefined) {
        this.mainresult = JSON.parse(this.dialogresult.data);
        if (this.mainresult.length != 0) {
          let Result = this.mainresult.map((choice) => choice.value);
          let text = confirm('Are you sure you want to export this file?');
          if (text == true) {
            if (this.exportcsvdata == true) {
              this.applyfilter(true);
              var postdata = {
                userId: '',
                userRole: 'Trader',
                name: '',
                state: '',
                district: '',
                search: this.filterbytext,
                marketPlace: '',
                mobileNo: '',
                documentStatus:
                  this.filterbydocumentStatus === 'All'
                    ? ''
                    : this.filterbydocumentStatus,
                reportKeyList: Result,
              };
              this._userService
                .getDocumentUserReport(postdata)
                .subscribe((data) => {
                  this.apidata = data;
                  const blob = new Blob([this.apidata], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  });
                  const url = window.URL.createObjectURL(blob);
                  var anchor = document.createElement('a');
                  anchor.download = 'PKF_document';
                  anchor.href = url;
                  anchor.click();
                });
            } else {
              postdata = {
                userId: '',
                userRole: 'Trader',
                name: '',
                state: '',
                district: '',
                marketPlace: '',
                mobileNo: '',
                documentStatus: '',
                search: '',
                reportKeyList: Result,
              };

              this._userService
                .getDocumentUserReport(postdata)
                .subscribe((data) => {
                  this.apidata = data;
                  const blob = new Blob([this.apidata], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  });
                  const url = window.URL.createObjectURL(blob);
                  // window.open(url);
                  var anchor = document.createElement('a');
                  anchor.download = 'PKF_document.xlsx';
                  anchor.href = url;
                  anchor.click();
                });
            }
          } else {
            this.openDialogexport();
          }
        } else {
          alert('Please select atleast any one columns to generate report!');
          this.openDialogexport();
        }
      }
    });
  }
  /*===================================================== Export File =========================================  */

  showimage() {
    // var postdata = {
    //   "userid": "E7906841-86CF-4B25-9C12-7AD85C39F413",
    // }
    // this._userService.getdocumentlist(postdata).subscribe((dcumentdata)=>{
    //   this.base64 = dcumentdata;
    //   this.listurl =this.base64.result.data;
    //   this.items = this.listurl.map(item => new ImageItem(this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64,${item.documentUrl}`)));
    //   this.items_result = this.listurl.map(item =>  item.documentUrl);
    // this.imageShow1 = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/jpg;base64, ${this.listurl}`);
    // this.data_list = this.listurl.map(items1 => new ImageItem({ src:this.imageShow1}));
    // })
  }
  /*====================================================View Profile ================================================================ */
  city: string;
  name: string;
  food_from_modal: string;

  openDialog(data): void {
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 1000);
    const dialogRef = this.dialog.open(UserProfileComponent, {
      width: '60%',
      height: '80%',
      data: { name: data.personId },
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  // image zoom in and zoom out

  /* open model pop up */
  /*====================================================View Profile ================================================================ */
  /*============================================Reason for reject ============================================================== */

  /*============================================Reason for reject ============================================================== */
}

export interface PeriodicElement {
  DocumentName: string;
  Date: string;
  Status: string;
  IsVerified: string;
  UploadedBy: string;
}

//colunm based export fuctionality
@Component({
  selector: 'document-export',
  templateUrl: 'document-export.html',
})
export class DocumentExport {
  response;
  title = 'Select/ Unselect All Checkboxes';
  masterSelected: boolean;
  checklist: any;
  checkedList: any;
  constructor(
    public dialogRef: MatDialogRef<DocumentExport>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) {
    this.masterSelected = false;
    this.checklist = [
      { id: 1, viewValue: 'Name', value: 'Name', isSelected: false },
      { id: 2, viewValue: 'Phone Number', value: 'PhoneNo', isSelected: false },
      {
        id: 3,
        viewValue: 'Document Status',
        value: 'DocumentStatus',
        isSelected: false,
      },
      { id: 4, viewValue: 'Address', value: 'Address', isSelected: false },
      { id: 5, viewValue: 'Mandi', value: 'Mandi', isSelected: false },
      { id: 6, viewValue: 'States', value: 'States', isSelected: false },
      { id: 7, viewValue: 'District', value: 'District', isSelected: false },
      { id: 8, viewValue: 'Company', value: 'Company', isSelected: false },
      { id: 9, viewValue: 'About Us', value: 'AboutUs', isSelected: false },
      {
        id: 10,
        viewValue: 'Commodity Trade Interested',
        value: 'CommTradeInterest',
        isSelected: false,
      },
      { id: 11, viewValue: 'Email Id', value: 'EmailId', isSelected: false },
      { id: 12, viewValue: 'Rating', value: 'Rating', isSelected: false },
      {
        id: 13,
        viewValue: 'Frequency for Requirement',
        value: 'ReqFrequency',
        isSelected: false,
      },
      {
        id: 14,
        viewValue: 'Verified By',
        value: 'Verifiedby',
        isSelected: false,
      },
    ];
    this.getCheckedItemList();
  }
  //  onNoClick(): void {
  //   // this.dialogRef.close();
  //  }
  ngOnInit(): void {
    // this.getCheckedItemList();
  }

  // The master checkbox will check/ uncheck all items
  checkUncheckAll() {
    for (var i = 0; i < this.checklist.length; i++) {
      this.checklist[i].isSelected = this.masterSelected;
    }
    this.getCheckedItemList();
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.masterSelected = this.checklist.every(function (item: any) {
      return item.isSelected == true;
    });
    this.getCheckedItemList();
  }
  // Get List of Checked Items
  getCheckedItemList() {
    this.checkedList = [];
    for (var i = 0; i < this.checklist.length; i++) {
      if (this.checklist[i].isSelected)
        this.checkedList.push(this.checklist[i]);
    }
    this.checkedList = JSON.stringify(this.checkedList);
  }
  closeDialog() {
    this.dialogRef.close({ data: this.checkedList });
  }
  closeDialogtest() {
    this.dialogRef.close();
  }
}
